export default __webpack_public_path__ + "static/media/posx.65768dad.jpg";